import { jsx as _jsx } from "react/jsx-runtime";
import { Button, DatePicker, Form, App, } from 'antd';
import { txt } from 'libs/i18n';
import FormModal from 'components/FormModal';
import { useSession } from 'components/Authenticated';
import { useEditorContext } from '../../contexts/projectSignal';
import { updateProjectDescription } from '../../update-project-description';
export const StartTimeDialog = ({ open, onClose, startDatetime, enqueueProjectUpdate, }) => {
    const [form] = Form.useForm();
    const { session } = useSession();
    const { message } = App.useApp();
    const { projectSignal } = useEditorContext();
    const projectId = projectSignal.peek().id;
    const { description } = projectSignal.peek();
    const handleFinish = async (values) => {
        var _a;
        await updateProjectDescription({
            connection: session.connection,
            projectId,
            currentDescription: description,
            updates: {
                start: (_a = values.start) !== null && _a !== void 0 ? _a : null,
            },
            enqueueProjectUpdate,
            message,
            onSuccess: onClose,
        });
        onClose();
    };
    return (_jsx(FormModal, { muteShortcuts: ['Tab', 'Shift+Tab'], title: txt('transcriptionStart'), open: open, onCancel: onClose, getContainer: () => document.body, footer: [
            _jsx(Button, { onClick: onClose, children: txt('close') }, "back"),
            _jsx(Button, { type: "primary", htmlType: "submit", form: "start-datetime-form", children: txt('save') }, "submit"),
        ], children: _jsx(Form, { id: "start-datetime-form", form: form, labelCol: { span: 8 }, onFinish: handleFinish, initialValues: {
                start: startDatetime,
            }, children: _jsx(Form.Item, { name: "start", label: txt('transcriptionStart'), children: _jsx(DatePicker, { format: ['DD/MM/YYYY HH:mm:ss'], showTime: {
                        format: 'HH:mm:ss',
                    } }) }) }) }));
};
